import { module } from 'angular';
import component from './kdatatable.component';

export default module('app.kdatatable', [])
	.component('kdatatable', component)
	.name;
